import { DesignConfigCategories } from '../designConfig';
import { Shapes, Styles, Types } from '../menu';

interface MenuItemType {
  category: string;
  colorGroup?: string;
  isPopular?: boolean;
  shape?: string;
  size?: string;
  style?: string;
  textureId: number;
  thumbnail?: string;
  type: Types;
}

enum ColorGroup {
  BEIGE = 'Beiges',
  BLUE = 'Blues',
  BROWN = 'Browns',
  GRAY = 'Grays',
  GREEN = 'Greens',
  RED = 'Reds',
  DARK = 'Darks',
  MIXED = 'Mixed',
}

const MenuItems = [
  // Shingled Siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 23,
    shape: Shapes.STRAIGHT_SHAKE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 24,
    shape: Shapes.STAGGERED_SHAKE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 814,
    shape: Shapes.SCALLOPED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.SHINGLED_SIDING,
    textureId: 1839,
    shape: Shapes.HAND_SPLIT,
  },
  // Concrete
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.POURED,
    textureId: 446,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 29,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/t4nmpum8fgn8zb851gtzcr53zn9f',
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 140,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/tz7b3q6yuoa8p3hcgwk9thrcxbrv',
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 447,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/z48s5uqg0sue05mnusc91fj9r9t7',
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.CONCRETE,
    style: Styles.CINDERBLOCK,
    textureId: 141,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/fmraiq1yuogvcpurtyl7p916xbs1',
  },

  // Brick
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 47,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/1zqxritk3twjarku0d1qaeym7rt1',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 194,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/3xr4kodu1jsqyi56keafuyzycwa9',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 433,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/vdk06w0j00es6xv0otw6bcywehh5',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 143,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/j168ik0gwyozg3m3ew9tjpgn0xph',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 449,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/1jil4ydg2vzpi183rbhcggm8q5vb',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 163,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/4fwz93wbyq5viwyi3acbjf25pncv',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 448,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/zvh6rd074ao0cpx7je9mnxbpsnzr',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 307,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/yus4u010w9mjw6zqfnsrh8rfx94v',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 190,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/fnhzlpdxuy79f2jxbrt2ifsrmbv2',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 131,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qpx91l9ljbw9lf4sxhlzf4menkjv',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 207,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/vy8niiwv4kox499gpsuqv0bwc5g0',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 793,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8q1636ovwpeefsawauhearfs0ojk',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 792,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ep31y98o0d8u0hzflv603ysy6qzj',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 135,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xwdvxkoffe6fd3wd2eu26xl6uczc',
    colorGroup: ColorGroup.RED,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 162,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/lx7168dx0mph7vf6nf58hxnaeza7',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 87,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/k4ryaue4adbgpehzzm4vmhynrp2b',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 321,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xkrx0ns4ommogwut50abzjpa7v1n',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 320,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/5ys5kjm43dreo1gn295dwwe1vnx1',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 239,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/6b6dr9d9n1jbbui5xfwkjffdil2p',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 368,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/g3aukxybrk0cd0fs3f7el311acsd',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 110,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/0utm1q3vf1x0rn9v1bm7cudoov82',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 246,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/mt6rqnzyhab8unsfwvidboojvxa7',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 136,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8i48ks1c8sejsubwiqwdjhmwpuno',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 331,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/sz92x65l2yju8nm24dbc3622usde',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 510,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/j8h81d7dt40f5h26mrjxpzsqihhx',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 398,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xc88xf1ozm80dsafomsl6m9ml8ev',
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 336,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/2my8g76e4hd1c8jkef9dyixqrzv8',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.BRICK,
    textureId: 36,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qeh2b3h4idapeffqoo77zut0dd03',
    colorGroup: ColorGroup.DARK,
  },

  // Stucco
  {
    category: DesignConfigCategories.WALL,
    type: Types.STUCCO,
    textureId: 88,
  },
  // Horizontal Siding

  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `3"`,
    textureId: 624,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `4"`,
    textureId: 2270,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `5"`,
    textureId: 623,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `6"`,
    textureId: 625,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `7"`,
    textureId: 626,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `8"`,
    textureId: 1299,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `10"`,
    textureId: 172,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.LAP,
    size: `12"`,
    textureId: 373,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `4"`,
    textureId: 1343,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `4.5"`,
    textureId: 1906,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.HORIZONTAL_SIDING,
    style: Styles.DUTCH_LAP,
    size: `5"`,
    textureId: 1446,
  },
  // Vertical Siding
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `5"`,
    textureId: 1819,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `7"`,
    textureId: 1987,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `8"`,
    textureId: 1267,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `10"`,
    textureId: 1641,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.BOARD_AND_BATTEN,
    size: `12"`,
    textureId: 1268,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `5"`,
    textureId: 1280,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `8"`,
    textureId: 739,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.PANEL,
    size: `10"`,
    textureId: 1479,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.VERTICAL_SIDING,
    style: Styles.TUDOR,
    textureId: 406,
  },

  // Stone
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 184,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qqq27zvb8llhbo5y0p1f3aov84ej',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 185,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8n8ujtrj5g66uosefvw5g4p36mh9',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 181,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/q01waz92i4ug0cyq1s767tbt8qtt',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 90,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/rsx2e2rpve7g7t4bvq7d82nt447k',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 188,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/r5uswi5don6wu4f1ccyer3h6bllf',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 195,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/5bhqy0jj3tzrcrzh9jvz2soed20c',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 756,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/e9yt5or3yp1ar5ud4tr3ttcb9o6n',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 726,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8tnr5yfwhw45mmbnul4oj67esvr8',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 727,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/gx1jylupve7adlzv17ywdau8c3hh',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 91,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/kkiid7v873rbphbkxuw6k0zj61qs',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 749,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qru42abjwyw5ev2ag74iv9veae38',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 177,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/dco8hzjw1hmhj3i7hyty4k2t0inr',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 316,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xosb5jf19eypi0602y48nvdv2f0y',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 180,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/fa4gi0ohwjaz9to9gp5z1w0w3e49',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 754,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/2zk472gz9wqwdcj23n35b00ktmmn',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 753,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/6bzps54kk3zotsu4u1tts6hwh6j8',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 747,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/30q3ih53ywru94jlz3wkhis2xp55',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 198,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/1o3ci7zsthvkzdjgeo84ic77bnnp',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 724,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/hyyge1rujem9tbr9j9mmtf1g1thu',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 179,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/fm632x0z919vcse6jqp3w9uy0voi',
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 752,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/kwudwvct372gxlorr0emiszw0g2h',
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 757,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/z596abzl70vrezzsyg2g9b7u3c1m',
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 755,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/l116sc4pva7zw5h5n4d537jeha9c',
    colorGroup: ColorGroup.MIXED,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 253,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/kvelsmmjku3vxe6pk9i4htdk400k',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 751,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/88i595scaw5t8o5iqv3bx8lhpx07',
    colorGroup: ColorGroup.DARK,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 280,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/m1nn3e4ewp8gfl0dpzf6mp26k4eb',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 390,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/afo601xohv2q50ij6gws2qkpygay',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 183,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/r0glw0z00u669bdmzam36kbs6zsf',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 196,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/twklht1hb85bl3a6xo6z9yafl8dq',
    colorGroup: ColorGroup.DARK,
  },
  {
    category: DesignConfigCategories.WALL,
    type: Types.STONE,
    textureId: 748,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/oevudk3r0prr68xax7pokxcqas10',
    colorGroup: ColorGroup.DARK,
  },

  // roof
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 563,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ejny805llgfg8wdo30bas0i7a6ji',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 557,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/2u1c8zle8blvs1qm8vavhp9syfro',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1558,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8jugyn3guv248zs4zu7trsc056y3',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 554,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/iddxytsizq4dxziakfghij96xtjt',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 560,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/50zxhzwiplw1jjczdm9c8ey6h4tj',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 568,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/j9iq515fae4yb97lta706juujr2y',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 565,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/tkk22lwu55heo6zxerg3b8phczqw',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 851,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/u68htkgfa5uiwh6x2l51r1dqkoiu',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 859,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/0zyrl598lrfoajgdmjghix7n5hoo',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2207,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/w0jmblbo3ch01ls63drixyobsybl',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 556,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/l8acakoltshny8z7tvphzr7eegbc',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 858,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ug5eyy5h2km7yatbh0nu2ka0fvfk',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1547,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/64bfakqnp8kett6bdu7el6um7qbn',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2213,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/372n34zwm06aupi3uhze95i81ka3',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 564,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/owin0jkldmip5om2jj0w4nhj1au2',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 555,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/lmf2f77worrzj3brwnhoz9o7jhhw',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1545,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/sacmcdiant8cpas6zuxh7corm9f1',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 562,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/y5ti3j6ig5mgagz4sj7nfmlb60vu',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2210,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/3bvw1py9pweit8yjkc4ew6wtf9ns',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 569,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/jpuhpczaaare4p4yjko3vpmrmiwq',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 160,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/7dgffhz23dd5ff4ntnggkixipa9t',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 524,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/1kr80n6oszwtpnfufhpkcsixb5kv',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 617,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/l09ril4n3xs6hs8o9lkpialer0sv',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 619,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/x2jcu4qjn4aecc7zak82ofp1vd9l',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 651,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/n75k6q15j11h71xbrj04vizckp63',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 527,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/dq9omoapdgv9d1xlkpr3jx4n3gca',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 101,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/dbifgrtizttnwy8bq1ilrpybzde5',
    colorGroup: ColorGroup.BEIGE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 951,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/lw1xwx16xc6t4jxu7fra13xntl15',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 971,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/lq1ldh75vt29hrmygwja96zvtnyr',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 734,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/sx9snvyrlz9opvzpevpahkufmys5',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 541,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/j75k97e73g0lrwf788w04wa2gzvr',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 653,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qf9c55i6rmg2cjqk4l4hh16arrkg',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 542,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/x8rno1czxico3goqjid0im884d9a',
    colorGroup: ColorGroup.BLUE,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 533,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/l7n77v47vgpwf9knn2qd0xd7lnnd',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 515,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/6u21loruq1kulnocmaomatfm5i9j',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 531,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/d469s8v1ulhz734dz9hkh7m15azq',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 950,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/bqg42g1oi6xrwzvohr3bkt6cstu4',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 548,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/pbpe913n73qpxbnk5t2jeilk74v2',
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 98,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xyb49yhmya45bcjm9rxrdzzj4fov',
    colorGroup: ColorGroup.BROWN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 965,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/9jd5gwzrobghe3n63q6eb3s8oahn',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 523,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/7j7xjr0b0i256xgkdt1pwvoc3q7r',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 534,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ennkqu934xl7d70t5n0kktcqda70',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 532,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/brwap2c8l5ekf4tm4k92x1rs8pdc',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 543,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/x86b7anstq4yyo9w7sqzmw575w4i',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 553,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/udftjoolcvms0hrnzr6ozrtn6nkj',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 158,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8df17sqgugckhsdc4hvh17y3pawt',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 537,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/db5u0g7g4tk5m51svfdszmk2rubr',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 99,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xr29w0j1ejy85rgq3ov9xmq9ep6p',
    colorGroup: ColorGroup.GRAY,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 530,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/r11b9q302dew7zaunytktxrkh7co',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 161,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xs14r9oego7on49a3a62rkcjyhii',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 539,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/cudordmsixvgrcq3mdh53h57iyxs',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 614,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/yvrw6k3c8msqa9j77z2glusqpr0f',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 733,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/y358o2yqiknfr3j6vzywal3q9nde',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 552,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/tgmlmsoj05osyxy8fklj5pjbzwa0',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 540,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ry2zhap3wh57193v27lzbxeffcav',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 97,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/6ary2v272p4mflv40wmjgk22f3we',
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 550,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/t9x6vck6ba3qhk4azwd221x1v0r6',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 96,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/x6onjglynrg9oc8e8tkw7q251703',
    colorGroup: ColorGroup.GREEN,
    isPopular: true,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1310,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/yozk3fxhyb1kmrr6xuac1artc0p1',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 656,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/413hu31tz4kfpnlgn9r030jsyreu',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 963,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/9w8wuvl2xqn598c17eb3su2xijag',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 528,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/043atwuhr5ftjtkauglognu6j80l',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 529,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/z2jp530tomjisdn7mfifw9y38lb7',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 538,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/z4s7u8kwjpklvpkyz409n09xozuz',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 535,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/tydoocs3a951ez79fsgaqtvjvk92',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 611,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/2h4ynlhnaz9grwm4y55kl6xyfpec',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 581,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/b1goyw28d2pk131oh4rqi639ryow',
    colorGroup: ColorGroup.BEIGE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 873,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/4qvazqg15jxtt7r1me5wiz3g4j79',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 602,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/pe6nvt0ahjpwwpdfjgepi7i6m13y',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 591,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ulhalyal1wew8c83nvfdafcutcq0',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 577,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/nk2w2w6jid5ht6tiiepke2w9p7i1',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1160,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/j966m8qr83922axb5brkx5oxc2wt',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1191,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ha36ukubenxnewmi5c3g2cji3c35',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 588,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/597p5sduzy91ii8el69xo7wa109w',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 579,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/mkndhs0ddjchje5kwkepb90opjli',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 575,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/jmxw262vjmanzhgzmoh0rrjw787k',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1033,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ym7i0qt4scszkped60ni2xuqru9a',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1027,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/n5i8dp1nfjvue762mfconvc9dcsz',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1194,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/xqmsuvjxhpgjqpbgg14edi1x3w2t',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 576,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/vv4jb6iu204jwnpeqxut6td2k3a8',
    colorGroup: ColorGroup.BLUE,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1022,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/93wco23wq5i2lpebxidf1m1qd1hc',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 571,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/8ka8976y5z5rkc77yddo28lscvj1',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 578,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/cn3tgil7vhmfbyzzmagi2ymnkwur',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1207,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qhpe7ddbwcb3lmfz7jg52ndk9f01',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 599,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/fjh9ozrw0k5jzb25yzwwtsk2xsh5',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 897,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/nllylab5wwdzhng7xbbdwdgttahg',
    colorGroup: ColorGroup.BROWN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 608,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/ws543jdq73wrpiwjqql9cdm6po4p',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 609,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/s4w5pzcy8elragu5605qau4kbzv0',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2632,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/mpjpj3o4dhkmb0aem0doxaw2lirc',
    colorGroup: ColorGroup.GRAY,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 881,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/2281369v9deg2zzzlbmvacznwi11',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1032,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/g842nmuspgs10or1qfp4bd0bqf38',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1212,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/p5toqgttafwkglksapmmyrezuo1r',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1167,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/29oigofzszrgapnywvyo08akmjpb',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1192,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/9d4xi3o4hix94jnie3q9w28mb6zq',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 2626,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/q8nmcdo0vafgdnspamr89imo7j1a',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 615,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/zxp8fben90qhbdbqc7ywi49zk5le',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 1179,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/zncavgr927srp50dclhodnulqguw',
    colorGroup: ColorGroup.GREEN,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.ASPHALT,
    textureId: 606,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/qhij3xb9hzvi9rj6sg0unq0om2tb',
    colorGroup: ColorGroup.RED,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.METAL,
    textureId: 2302,
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 2202,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/evdt546fx4bjnio9hq8hkectzxvg',
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 104,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/oxn1pcmqcgw1wn31zot67c8ucucx',
  },
  {
    category: DesignConfigCategories.ROOF,
    type: Types.TILE,
    textureId: 490,
    thumbnail:
      'https://storage.googleapis.com/product-catalog-production-app-prod-fd4e/15ta8ytuisqxgeacbcxwtfvhpnzk',
  },
];

export { ColorGroup, MenuItems, MenuItemType };
